import React from "react";
import {
  Wallet,
  Clock3,
  Receipt,
  Plane,
  IndianRupee,
  Users,
} from "lucide-react";

import KpiCard from "../common/KpiCard";
import { financeDashboardData } from "../../data/financeMockData";

const DashboardCards = () => {
  const data = financeDashboardData.kpis;

  const cards = [
    {
      label: "Total Payroll",
      value: data.totalPayroll,
      sub: "Current Month",
      icon: <Wallet size={28} />,
      color: "#1B4B31",
    },
    {
      label: "Pending Payroll",
      value: data.pendingPayroll,
      sub: "Awaiting Approval",
      icon: <Clock3 size={28} />,
      color: "#1B4B31",
    },
    {
      label: "Expense Claims",
      value: data.expenseClaims,
      sub: "Pending Claims",
      icon: <Receipt size={28} />,
      color: "#1B4B31",
    },
    {
      label: "Travel Requests",
      value: data.travelRequests,
      sub: "Pending Approval",
      icon: <Plane size={28} />,
      color: "#1B4B31",
    },
    {
      label: "Monthly Expenses",
      value: data.monthlyExpenses,
      sub: "This Month",
      icon: <IndianRupee size={28} />,
      color: "#1B4B31",
    },
    {
      label: "Employees Paid",
      value: data.employeesPaid,
      sub: "Current Payroll",
      icon: <Users size={28} />,
      color: "#1B4B31",
    },
  ];

  return (
    <div className="kpi-grid">
      {cards.map((card, index) => (
        <KpiCard
          key={index}
          label={card.label}
          value={card.value}
          sub={card.sub}
          icon={card.icon}
          color={card.color}
        />
      ))}
    </div>
  );
};

export default DashboardCards;